import buttonRadar from '../shared/button-radar.vue'
import back from '../shared/back.vue'
import ratingComponent from '../shared/rating.vue'
import reviewsComponent from '../reviews/index.vue';


export default  {

  name: 'details',

  components: {

    reviewsComponent,
    ratingComponent,
    buttonRadar,
    back

  },


  data() {
    return {

      // Get the product data
      data: this.$store.state.product,

      promoPrice: null,

      price: null,

      percentage: null,

      priceDiff: null,

      selectedItem: this.$store.state.product.sizes[0],

      showReviews: false,

      productID: this.$route.params.product

    }
  },


  /*

    Lets watch for a new selection and animate the price

  */
  watch: {

    selectedItem: function() {

      //re instance vue (this)
      var vm = this;

      var animationFrame;

      /*

        set the current promotion price = the selected item promotion price

      */
      vm.promoPrice = vm.selectedItem.promo;


      /*

        the selected current item price
        (used for animate the difference between this value and the previous value)

        if selected item size has promotion price set it
        otherwise set the selected item normal price

      */
      var newPrice = vm.selectedItem.promo ? vm.selectedItem.promo : vm.selectedItem.price;


      /*

        the selected item old price
        if the selected item has a promo price, use the selected item old price
        otherwise use its original price

      */
      var oldPrice = vm.selectedItem.promo ? vm.selectedItem.price : vm.price;


      /*

        set the current price = selected item price
        can be the old price or the promotion price
        depends of 'oldPrice'

      */
      vm.price = oldPrice;


      function animate (time) {

        TWEEN.update(time);

        animationFrame = requestAnimationFrame(animate);

      }

      new TWEEN.Tween({ tweeningNumber: oldPrice })

          .easing(TWEEN.Easing.Quadratic.Out)

          .to({ tweeningNumber: newPrice }, 1000)

          .onUpdate(function () {

            /*

              if has promotion price
              update the promo price

            */
            if(vm.promoPrice){

              vm.promoPrice = this.tweeningNumber.toFixed(0);

            }

            /*

              otherwise
              update the original price

            */
            else{

              vm.price = this.tweeningNumber.toFixed(0);

            }


          })

          .onComplete(function () {

            //update the discount %
            vm.percentage = vm.calculate(oldPrice, newPrice);

            //update the price difference
            vm.priceDiff = (oldPrice - newPrice).toFixed(2);

            cancelAnimationFrame(animationFrame)

          })

          .start();

      animationFrame = requestAnimationFrame(animate);

    }
  },


  methods:{

    // Dropdown OnClick Method
    onClick(el){

      el.target.closest(".dropdown").classList.toggle('opened');

    },


    // Dopdown OnSelect item method
    onSelect(i){

      /*
        As the product sizes are static data in the state
        we can set the current selected item by getting the index of the clicked item in the dropdown
      */
      this.selectedItem = this.$store.state.product.sizes[i];

      // then set the promo price based on the selection
      this.promoPrice = this.selectedItem.promo;

    },


    //CALCULATE PROMOTION
    calculate(price, promo) {

      // Calculates the % discount based on Price and Promo Price

      let rest = price - promo;

      let discount = 100 * rest / price;
      console.log('[discount]', discount)
      return  discount.toFixed(0);

    },


    /* OnShowReviews Toggle method */
    onShowReviews(){

      // Show/hide the reviews panel
      this.showReviews = !this.showReviews;

    }

  },


  computed:{

    // Our reactive item
    reactiveItem:{

      /*
        Getter
        will init reactiveItem with the first mattress size value
      */
      get: function () {

        // Start by selecting the first item
        return this.$store.state.product.sizes[0];

      },

      /*
         Setter
         allow us to update the reactiveItem values and thus update price and promoPrice
      */
      set: function (newValue) {

        this.selectedItem = newValue;

      }

    },

    // Get the rating data form the store
    ratingData() {

      return this.$store.state.product.review;

    }

  },


  updated(){

    // Fallback, if price is null means that the the view was loaded before the store being ready
    if(this.promoPrice == null){

      // var vm = this;

      // Selected item will then be the Computed reactiveItem
      setTimeout(() => {

        this.selectedItem = this.reactiveItem;

      }, 500);

    }
  },


  mounted(){

    // Listen to showReviews event emit from reviews-component, so we know when to close the component
    this.$on('showReviews', (fromChild) => {

      this.showReviews = fromChild;

    });


    // INIT VALUES

    // Calculate percentage
    this.percentage = this.calculate(this.reactiveItem.price, this.reactiveItem.promo);

    // Price difference
    this.priceDiff = (this.reactiveItem.price - this.reactiveItem.promo).toFixed(2);
    // Start by getting the first item price
    this.price = this.reactiveItem.price;

    // Start by getting the first item promo price
    this.promoPrice = this.reactiveItem.promo;



    localStorage.setItem('play', true);

    let app = document.getElementById("app");
    app.style.backgroundImage = "";


  },

}




// WEBPACK FOOTER //
// ./src/components/details/details.component.js